import React, { useState } from 'react';
import { Button, Modal, ModalHeader, ModalBody } from 'reactstrap';
import { connect } from 'react-redux';
import { vmailPlayer } from '../actions/Vmails';

const VmailPlayer = ({ id = '', type = '', vmailPlayer }) => {
  const [modal, setModal] = useState(false);
  const token = localStorage.getItem('jwtToken');
  const toggle = () => setModal(!modal);

  return (
    <>
      <div>
        <Button color="secondary" onClick={toggle}>
          Play
        </Button>
        <Modal isOpen={modal} toggle={toggle}>
          <ModalHeader toggle={toggle}>Listening to Voice Mails</ModalHeader>
          <ModalBody style={{ display: 'flex', justifyContent: 'center' }}>
            {modal && (
              <audio
                id="audio"
                src={vmailPlayer(token, id, type)}
                preload="auto"
                controls
                muted={false}
                loop={false}
                autoPlay
              ></audio>
            )}
          </ModalBody>
        </Modal>
      </div>
    </>
  );
};

const mapDispatchToProps = {
    vmailPlayer,
};

export default connect(
  null,
  mapDispatchToProps,
)(VmailPlayer);
